import { render, staticRenderFns } from "./serverError.vue?vue&type=template&id=77df8c5e&"
import script from "./serverError.vue?vue&type=script&lang=js&"
export * from "./serverError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports